import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';
import { IAdminTablesState } from './state';

export const defaultState: IAdminTablesState = {
    tables: [],
    zones: [],
    selectedZone: null,
    selectedZoneId: null,
};

export const adminTablesModule = {
    state: defaultState,
    mutations,
    actions,
    getters
};